<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <el-form ref="form" :model="form" label-width="180px">
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" :class="c.className" />
    </el-form>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FixdDtail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'pcustom',
      breadcrumb: [
        { name: "客户管理", path: `/customer/carrier` },
        { name: "承运人管理", path: `/customer/carrier` },
        { name: "添加承运人" },
      ],
      formCtrl: [
        {
          label: "承运人",
          keyName: "pname",
          err: "请填写承运人姓名",
          type: "text",
        },
        {
          label: "公司名称",
          keyName: "company",
          err: "请填写公司名称",
          type: "text",
        },
        {
          label: "联系方式",
          keyName: "phone",
          err: "请填写联系方式",
          type: "text",
          //className:'de-adsu',
        },
        {
          label: "地址",
          keyName: "address",
          err: "请填写地址",
          type: "text",
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .el-input {
      width: 200px;
    }
    
  }

  // .el-textarea {
  //   width: 200px;
  // }
}
/deep/ .de-adsu .el-form-item__content input::-webkit-outer-spin-button, .de-adsu .el-form-item__content input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
// /deep/ .de-adsu .el-form-item__content input[type="number"]{
//   -moz-appearance: textfield;
// }
.btns {
  margin: 40px 0 60px 180px;
}
</style>
